import { render, staticRenderFns } from "./AddOrEditPatrolTask.vue?vue&type=template&id=390b977d&scoped=true&"
import script from "./AddOrEditPatrolTask.vue?vue&type=script&lang=js&"
export * from "./AddOrEditPatrolTask.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditPatrolTask.vue?vue&type=style&index=0&id=390b977d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b977d",
  null
  
)

export default component.exports